/* =============================================================
 * dopa-sticky-bar.js
 * Sticky profile bar ở bottom: "Nữ · ~62kg · Size M  [Đổi]"
 * - Xuất hiện sau khi khách set profile (dopa:profile_updated)
 * - Click "Đổi" → mở lại first-touch modal (DOPA.openFirstTouch)
 * - Reactive: tự update khi profile thay đổi
 * - Tự ẩn khi sticky-add-to-cart của theme đang active (mobile)
 * ============================================================= */

(function () {
  'use strict';

  var BAR_ID = 'dopa-sticky-bar';
  var bar = null;

  /* ── Build DOM ───────────────────────────────────────────── */
  function build() {
    if (document.getElementById(BAR_ID)) return;

    bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'dopa-sticky-bar';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');

    // Info section
    var info = document.createElement('div');
    info.className = 'dopa-sticky-bar__info';

    var icon = document.createElement('span');
    icon.className = 'dopa-sticky-bar__icon';
    icon.textContent = '👤';

    var text = document.createElement('span');
    text.className = 'dopa-sticky-bar__text';

    info.appendChild(icon);
    info.appendChild(text);

    // Edit button
    var editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'dopa-sticky-bar__edit';
    editBtn.textContent = 'Đổi thông số';
    editBtn.addEventListener('click', function () {
      if (window.DOPA && window.DOPA.openFirstTouch) {
        var profile = window.DOPA.getProfile ? window.DOPA.getProfile() : null;
        window.DOPA.openFirstTouch(profile ? profile.gender : null);
      }
    });

    bar.appendChild(info);
    bar.appendChild(editBtn);
    document.body.appendChild(bar);
  }

  /* ── Render profile into bar ─────────────────────────────── */
  function render() {
    if (!window.DOPA || !window.DOPA.getProfile) return;

    var profile = window.DOPA.getProfile();

    if (!profile) {
      hide();
      return;
    }

    if (!bar) build();

    var genderLabel = '';
    if (profile.gender === 'NAM') genderLabel = 'Nam';
    else if (profile.gender === 'NU') genderLabel = 'Nữ';

    var weightLabel = profile.weightRange
      ? profile.weightRange
      : ('~' + Math.round(profile.weightKg) + ' kg');

    var size = profile.suggestedSize || (window.DOPA.suggestSize ? window.DOPA.suggestSize(profile.weightKg) : null);

    var parts = [];
    if (genderLabel) parts.push(genderLabel);
    parts.push(weightLabel);

    var textEl = bar.querySelector('.dopa-sticky-bar__text');
    if (textEl) {
      textEl.innerHTML = parts.join(' · ') +
        (size ? ' · <span class="dopa-sticky-bar__size-badge">Size ' + size + '</span>' : '');
    }

    show();
  }

  function show() {
    if (!bar) return;
    // Trì hoãn nhỏ để tránh conflict với page load animation
    setTimeout(function () {
      if (bar) bar.classList.add('is-visible');
    }, 600);
  }

  function hide() {
    if (bar) bar.classList.remove('is-visible');
  }

  /* ── Conflict với sticky-add-to-cart của theme ───────────── */
  // Dopa sticky-bar nằm ở bottom. Một số theme cũng có sticky ATC cùng vị trí.
  // Giải pháp: offset bar lên nếu sticky ATC visible.
  function detectStickyAtcConflict() {
    var themeAtc = document.querySelector('.sticky-add-to-cart, .product-sticky-bar, [data-sticky-bar]');
    if (!themeAtc || !bar) return;

    function updateOffset() {
      if (!bar) return;
      var rect = themeAtc.getBoundingClientRect();
      var isVisible = rect.height > 0 && window.getComputedStyle(themeAtc).display !== 'none';
      if (isVisible) {
        bar.style.bottom = rect.height + 'px';
      } else {
        bar.style.bottom = '0';
      }
    }

    var obs = new MutationObserver(updateOffset);
    obs.observe(themeAtc, { attributes: true, attributeFilter: ['class', 'style'] });
    updateOffset();
  }

  /* ── Collection personalization banner (disabled) ────────── */
  // Inject banner phía trên product grid trên /collections/ pages
  function injectCollectionBanner() {
    return; // disabled: run silently, no visual banner
    // Chỉ chạy trên trang collection
    if (window.location.pathname.indexOf('/collections') === -1) return;
    if (!window.DOPA || !window.DOPA.getProfile) return;

    var profile = window.DOPA.getProfile();
    if (!profile || !profile.suggestedSize) return;

    // Không tạo banner trùng
    if (document.getElementById('dopa-collection-banner')) {
      // Nếu đã có rồi thì update text (trường hợp profile thay đổi)
      var existing = document.getElementById('dopa-collection-banner');
      var textEl = existing.querySelector('.dopa-collection-banner__text');
      if (textEl) textEl.innerHTML = buildBannerText(profile);
      return;
    }

    var banner = document.createElement('div');
    banner.id = 'dopa-collection-banner';
    banner.className = 'dopa-collection-banner';

    var icon = document.createElement('span');
    icon.className = 'dopa-collection-banner__icon';
    icon.textContent = '✓';

    var text = document.createElement('span');
    text.className = 'dopa-collection-banner__text';
    text.innerHTML = buildBannerText(profile);

    var editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'dopa-collection-banner__edit';
    editBtn.textContent = 'Đổi thông số';
    editBtn.addEventListener('click', function () {
      if (window.DOPA && window.DOPA.openFirstTouch) {
        var profile = window.DOPA.getProfile ? window.DOPA.getProfile() : null;
        window.DOPA.openFirstTouch(profile ? profile.gender : null);
      }
    });

    banner.appendChild(icon);
    banner.appendChild(text);
    banner.appendChild(editBtn);

    insertBanner(banner);
  }

  function buildBannerText(profile) {
    var size = profile.suggestedSize;
    var genderLabel = '';
    if (profile.gender === 'NAM') genderLabel = 'Nam';
    else if (profile.gender === 'NU') genderLabel = 'Nữ';
    var suffix = genderLabel ? ' · ' + genderLabel : '';
    return 'Đang lọc sản phẩm phù hợp với <strong>Size ' + size + suffix + '</strong>';
  }

  function insertBanner(banner) {
    var grid = document.querySelector('#CollectionProductGrid') ||
               document.querySelector('.collection-filters-results') ||
               document.querySelector('.collection__products') ||
               document.querySelector('.product-grid');

    if (grid && grid.parentNode) {
      grid.parentNode.insertBefore(banner, grid);
      return;
    }

    // Fallback: chờ grid render (Shopify AJAX / section render)
    var obs = new MutationObserver(function (_, observer) {
      var g = document.querySelector('#CollectionProductGrid') ||
              document.querySelector('.collection-filters-results') ||
              document.querySelector('.collection__products') ||
              document.querySelector('.product-grid');
      if (g && g.parentNode) {
        g.parentNode.insertBefore(banner, g);
        observer.disconnect();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    // Luôn có timeout fallback để tránh memory leak
    setTimeout(function () { obs.disconnect(); }, 5000);
  }

  /* ── Product card size badge highlight ───────────────────── */
  // Highlight variant radio buttons và card badges khớp với size profile
  function highlightSizeOnPage() {
    if (!window.DOPA || !window.DOPA.getProfile) return;
    var profile = window.DOPA.getProfile();
    if (!profile || !profile.suggestedSize) return;

    var size = profile.suggestedSize.toUpperCase();

    // 1) Auto-select matching size radio on product forms/pages
    var radios = document.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="size"]');
    radios.forEach(function (r) {
      var val = (r.value || '').toUpperCase();
      var label = r.closest('label') || document.querySelector('label[for="' + r.id + '"]');
      if (val === size) {
        if (!r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('input', { bubbles: true }));
          r.dispatchEvent(new Event('change', { bubbles: true }));
          if (label) label.click();
        }
        if (label) {
          label.style.outline = '2.5px solid var(--brand-primary)';
          label.style.outlineOffset = '2px';
          label.setAttribute('title', 'Size phù hợp với bạn');
        }
      }
    });

    // 2) Auto-select matching size on select dropdown variants
    var selects = document.querySelectorAll('select[name*="Size"], select[name*="size"], select[id*="Size"], select[id*="size"]');
    selects.forEach(function (sel) {
      var matched = null;
      Array.prototype.slice.call(sel.options).forEach(function (opt) {
        if (matched) return;
        var text = (opt.text || '').toUpperCase();
        var val = (opt.value || '').toUpperCase();
        if (text === size || val === size || text.indexOf(' ' + size + ' ') >= 0 || text.endsWith(' ' + size)) {
          matched = opt;
        }
      });
      if (matched && sel.value !== matched.value) {
        sel.value = matched.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 3) Keep subtle recommendation marker on swatches
    var swatches = document.querySelectorAll('[data-value]');
    swatches.forEach(function (sw) {
      if ((sw.getAttribute('data-value') || '').toUpperCase() === size) {
        sw.setAttribute('data-dopa-recommended', 'true');
      }
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    // Bottom sticky profile bar disabled (UX issue: intrusive footer strip).
    // build();
    // render();
    // detectStickyAtcConflict();

    // Listen for profile updates
    document.addEventListener('dopa:profile_updated', function () {
      highlightSizeOnPage();
    });

    // Also listen storage event (cross-tab)
    window.addEventListener('storage', function (e) {
      if (e.key === 'dopa_body_profile') {
        highlightSizeOnPage();
      }
    }, { passive: true });

    // On page load if profile exists
    if (window.DOPA && window.DOPA.getProfile && window.DOPA.getProfile()) {
      highlightSizeOnPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
